var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/desktop-computer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 4.16675C1.66797 2.78604 2.78726 1.66675 4.16797 1.66675H15.8346C17.2153 1.66675 18.3346 2.78604 18.3346 4.16675V12.5001C18.3346 13.8808 17.2153 15.0001 15.8346 15.0001H12.9436L13.2538 16.2407L13.9239 16.9108C14.1622 17.1492 14.2335 17.5076 14.1045 17.819C13.9756 18.1304 13.6717 18.3334 13.3346 18.3334H6.66797C6.33092 18.3334 6.02705 18.1304 5.89807 17.819C5.76909 17.5076 5.84038 17.1492 6.07871 16.9108L6.74883 16.2407L7.05899 15.0001H4.16797C2.78726 15.0001 1.66797 13.8808 1.66797 12.5001V4.16675ZM3.33464 11.6667V12.5001C3.33464 12.9603 3.70773 13.3334 4.16797 13.3334H8.10761C8.11962 13.3332 8.13166 13.3332 8.14374 13.3334H11.8589C11.8709 13.3332 11.883 13.3332 11.895 13.3334H15.8346C16.2949 13.3334 16.668 12.9603 16.668 12.5001V11.6667H3.33464ZM16.668 10.0001H3.33464V4.16675C3.33464 3.70651 3.70773 3.33341 4.16797 3.33341H15.8346C16.2949 3.33341 16.668 3.70651 16.668 4.16675V10.0001ZM11.2257 15.0001H8.77695L8.36028 16.6667H11.6423L11.2257 15.0001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopComputer);
export default __webpack_public_path__ + "static/media/desktop-computer.25b46f06aebe4ba347177b961cc3326c.svg";
export { ForwardRef as ReactComponent };